"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PhoneSpeakerFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_PhoneSpeakerFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.445 0H2.667A2.66 2.66 0 0 0 .782.782 2.66 2.66 0 0 0 0 2.666C0 10.036 5.964 16 13.334 16h.081c1.44-.009 2.585-1.226 2.585-2.666v-1.779c0-.981-.796-1.777-1.778-1.777h-1.561c-.708 0-1.386.28-1.886.781l-.72.72a.907.907 0 0 1-.637.267.822.822 0 0 1-.364-.084 9.8 9.8 0 0 1-4.516-4.515.882.882 0 0 1 .184-1.002l.72-.72c.5-.5.78-1.178.78-1.885V1.778C6.222.796 5.426 0 4.445 0ZM7.5 1A.5.5 0 0 1 8 .5 7.5 7.5 0 0 1 15.5 8a.5.5 0 0 1-1 0A6.5 6.5 0 0 0 8 1.5a.5.5 0 0 1-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5a.5.5 0 0 0 0 1A2.5 2.5 0 0 1 10.5 8a.5.5 0 0 0 1 0A3.5 3.5 0 0 0 8 4.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_PhoneSpeakerFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = PhoneSpeakerFill;
exports["default"] = _default;